import originDayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import 'dayjs/locale/ja';

// プラグイン拡張と日本時間のデフォルト設定
originDayjs.extend(utc);
originDayjs.extend(timezone);
originDayjs.extend(isSameOrAfter);
originDayjs.locale('ja');
originDayjs.tz.setDefault('Asia/Tokyo');

// tz をデフォルトで適用するファクトリにラップ
const DateTimeFactory = ((input?: originDayjs.ConfigType) => {
  return input !== undefined ? originDayjs.tz(input) : originDayjs.tz();
}) as typeof originDayjs;

Object.assign(DateTimeFactory, originDayjs);

export const DateTime = DateTimeFactory;
export type { Dayjs, ConfigType } from 'dayjs';


